import I18nProvider from 'next-translate/I18nProvider';
import React from 'react';

import accountTranslations from '~/domains/account/locales/en';
import appTranslations from '~/domains/app/locales/en';
import authTranslations from '~/domains/auth/locales/en';
import channelTranslations from '~/domains/channel/locales/en';
import chatTranslations from '~/domains/design-system/components/Chat/locales/en';
import commissionerTranslations from '~/domains/commissioner/locales/en';
import commonTranslations from '~/domains/common/locales/en';
import contestTranslations from '~/domains/contest/locales/en';
import entrantsManagerTranslations from '~/domains/entrants-manager/locales/en';
import faqsTranslations from '~/domains/faqs/locales/en';
import formsTranslations from '~/domains/forms/locales/en';
import homeTranslations from '~/domains/home/locales/en';
import groupTranslations from '~/domains/group/locales/en';
import invitesManagerTranslations from '~/domains/invites-manager/locales/en';
import manageContestTranslations from '~/domains/manage-contest/locales/en';
import marketTranslations from '~/domains/market/locales/en';
import marketplaceTranslations from '~/domains/marketplace/locales/en';
import notificationsTranslations from '~/domains/notifications/locales/en';
import partnerPortalTranslations from '~/domains/partner-portal/locales/en';
import loyaltyTranslations from '~/domains/promotions/domains/gamification/locales/en';
import paymentsTranslations from '~/domains/payments/locales/en';
import promotionsTranslations from '~/domains/promotions/locales/en';
import tutorialsTranslations from '~/domains/tutorials/locales/en';
import userTranslations from '~/domains/user/locales/en';

const NumberFormatters = {
  en: new Intl.NumberFormat('en-EN'),
};

type TranslationsProviderProps = {
  children: React.ReactNode;
};

function TranslationsProvider({ children }: TranslationsProviderProps) {
  return (
    <I18nProvider
      lang="en"
      namespaces={{
        app: appTranslations,
        channel: channelTranslations,
        chat: chatTranslations,
        common: commonTranslations,
        user: userTranslations,
        contest: contestTranslations,
        payments: paymentsTranslations,
        promotions: promotionsTranslations,
        commissioner: commissionerTranslations,
        faqs: faqsTranslations,
        tutorials: tutorialsTranslations,
        forms: formsTranslations,
        auth: authTranslations,
        account: accountTranslations,
        group: groupTranslations,
        home: homeTranslations,
        'invites-manager': invitesManagerTranslations,
        market: marketTranslations,
        marketplace: marketplaceTranslations,
        notifications: notificationsTranslations,
        'entrants-manager': entrantsManagerTranslations,
        'manage-contest': manageContestTranslations,
        'partner-portal': partnerPortalTranslations,
        loyalty: loyaltyTranslations,
      }}
      config={{
        interpolation: {
          format: (value, format, lang) => {
            if (format === 'number' && NumberFormatters[lang]) {
              return NumberFormatters[lang].format(value);
            }

            return value;
          },
        },
        logger: process.env.NODE_ENV === 'test' ? () => {} : undefined,
      }}
    >
      {children}
    </I18nProvider>
  );
}

export default TranslationsProvider;
